import Receptiondetailt1 from "./receptiondetailt1";
import Receptiondetailt2 from "./receptiondetailt2";
import Sidebaradmin from "./sidebaradmin"

function Receptiondetails(){
    return(
<>
<Sidebaradmin>
    
</Sidebaradmin>
<Receptiondetailt1>

</Receptiondetailt1>
<Receptiondetailt2>

</Receptiondetailt2>
</>
    )
}

export default Receptiondetails;